import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { subDays } from 'date-fns';
import { useState } from 'react';
import DateRangePickerDropdown from '../../../components/DateRangePickerDropdown';
import { useUserStore } from '../../../components/userStore';
import constants from '../../../constants';
import TopReferringOrgs from './components/TopReferringOrgs';
import TopServiceCategories from './components/TopServiceCategories';

const ReportingDashboard = () => {
	const [startDate, setStartDate] = useState(subDays(new Date(), 30));
	const [endDate, setEndDate] = useState(new Date());
	const { user } = useUserStore();
	const { data } = useQuery({
		queryKey: ['reporting-dashboard', user.coord_agency.id, startDate, endDate],
		queryFn: async () => {
			const { data } = await axios.get(
				`/coord_agencies/${user.coord_agency.id}/reporting-data`,
				{
					params: {
						options: {
							startDate,
							endDate,
						},
					},
				},
			);
			return data;
		},
	});

	const handleDateRangeChange = ({ startDate, endDate }) => {
		setStartDate(startDate);
		setEndDate(endDate);
	};

	return (
		<div className="grid grid-cols-4 gap-4 pb-4">
			<div className="flex flex-row-reverse col-span-4 gap-4">
				<DateRangePickerDropdown
					startDate={startDate}
					endDate={endDate}
					onRangeChosen={handleDateRangeChange}
				/>
			</div>
			<div className="p-4 bg-white border rounded-xl">
				<div className="text-sm">Open Agency Referrals</div>
				<div className="mt-2 text-xl">
					<strong>
						{data?.reduce((prevVal, nextRow) => {
							if (
								nextRow.ref_agency_id &&
								!Object.keys(constants.shortStatus).includes(
									nextRow.request_status,
								)
							) {
								prevVal++;
							}
							return prevVal;
						}, 0)}
					</strong>
				</div>
			</div>
			<div className="p-4 bg-white border rounded-xl">
				<div className="text-sm">Closed Agency Referrals</div>
				<div className="mt-2 text-xl">
					<strong>
						{data?.reduce((prevVal, nextRow) => {
							if (
								nextRow.ref_agency_id &&
								Object.keys(constants.shortStatus).includes(
									nextRow.request_status,
								)
							) {
								prevVal++;
							}
							return prevVal;
						}, 0)}
					</strong>
				</div>
			</div>
			<div className="p-4 bg-white border rounded-xl">
				<div className="text-sm">Open Self-service Referrals</div>
				<div className="mt-2 text-xl">
					<strong>
						{data?.reduce((prevVal, nextRow) => {
							if (
								!nextRow.ref_agency_id &&
								!Object.keys(constants.shortStatus).includes(
									nextRow.request_status,
								)
							) {
								prevVal++;
							}
							return prevVal;
						}, 0)}
					</strong>
				</div>
			</div>
			<div className="p-4 bg-white border rounded-xl">
				<div className="text-sm">Closed Self-service Referrals</div>
				<div className="mt-2 text-xl">
					<strong>
						{data?.reduce((prevVal, nextRow) => {
							if (
								!nextRow.ref_agency_id &&
								Object.keys(constants.shortStatus).includes(
									nextRow.request_status,
								)
							) {
								prevVal++;
							}
							return prevVal;
						}, 0)}
					</strong>
				</div>
			</div>
			<div className="col-span-4 p-4 bg-white border rounded-xl">
				<TopReferringOrgs data={data} />
			</div>
			<div className="col-span-4 p-4 bg-white border rounded-xl">
				<TopServiceCategories data={data} />
			</div>
		</div>
	);
};

export default ReportingDashboard;
